/* eslint-disable */
import React, { PureComponent, Fragment } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, FormGroup, CustomInput, Form } from 'reactstrap'
import _ from 'lodash'
import { fetchManageUsers } from './../../actions'
import { connect } from 'react-redux'
import ModalItem from '../ModalItem/ModalItem'
import Loader from 'react-loaders'
import { userInfo } from 'os';

class MainModal extends PureComponent {
  componentDidMount = () => {
    this.props.fetchManageUsers()
  }

  constructor(props) {
    super(props)
    this.state = {
      modal: false
    }

    this.toggle = this.toggle.bind(this)
  }

  toggle() {
    this.setState({
      modal: !this.state.modal
    });
  }

  _createData = (data) => {
    const sorted = {}
    data.forEach(item => {
      const {
        id,
        name,
      } = item
      sorted[id] = {
        id,
        name
      }
    })
    return sorted
  }

  _renderItems = () => {
    const { manageUsers, handleCheck, members } = this.props
    if (manageUsers.loading) {
      return <div className="table_center">
        <Loader type="ball-pulse" />
      </div>
    }
    if (!manageUsers.data) return null
    // console.log('residentsdata:', this.props.manageUsers.data)
    // console.log(this._createData(manageUsers.data))
    return (
      _.map(this._createData(manageUsers.data), (value, name) => {
        // console.log('value:',value,'name:',name)
        // console.log('name', name, typeof name)
        // console.log('members', members)

        return (
          <Fragment key={name}>
           <CustomInput className="ml-4" type="checkbox" id={`Users_${name}`} label={value.name} onChange={(e)=>handleCheck(value, e)} checked={members.some(member => member.id === value.id)} />
          </Fragment>
        )
      })
    )
  }

  render() {
    return (
      <span className="d-block mb-2">
        <Button color="primary" onClick={this.toggle}>{this.props.modalTitle}</Button>
        <Modal isOpen={this.state.modal} toggle={this.toggle} className={this.props.className}>
          <ModalHeader toggle={this.toggle}>{this.props.modalTitle}</ModalHeader>
          <ModalBody>
            <Form>
              <FormGroup>
                {this._renderItems()}
              </FormGroup>
            </Form>
          </ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={this.toggle}>閉じる</Button>
          </ModalFooter>
        </Modal>
      </span>
    );
  }
}

const mapStateToProps = ({ manageUsers }) => ({
  manageUsers
})

const mapDispatchToProps = {
  fetchManageUsers
}

export default connect(mapStateToProps, mapDispatchToProps)(MainModal)
